import {fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const findUserLoginSession = (
    successMethod,
    errorMethod,
    getAccessToken
) => {
    const params = {
    };
    fetchPost(
        uri + "/user/session",
        successMethod,
        errorMethod,
        params,
        getAccessToken);
};
